import type { SVGProps } from 'react';

export function HamsaIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.698 13.2H5.4c.33 0 .6-.27.6-.6V5.1a1.5 1.5 0 1 1 3 0v4.95c0 .412.338.75.75.75s.75-.338.75-.75V3.9a1.5 1.5 0 1 1 3 0v6.15c0 .412.338.75.75.75s.75-.338.75-.75V5.1a1.5 1.5 0 1 1 3 0v7.5c0 .33.27.6.6.6h1.702a1.298 1.298 0 0 1 .96 2.171l-3.24 3.566a8.14 8.14 0 0 1-12.044 0l-3.24-3.566a1.298 1.298 0 0 1 .96-2.171m8.302 0c-1.44 0-2.88 1.342-3.397 1.882a.74.74 0 0 0-.203.518c0 .191.068.379.203.517C9.12 16.657 10.56 18 12 18s2.88-1.343 3.398-1.883a.74.74 0 0 0 .202-.517.74.74 0 0 0-.202-.518C14.88 14.542 13.44 13.2 12 13.2m0 1.2c.664 0 1.2.536 1.2 1.2s-.536 1.2-1.2 1.2-1.2-.536-1.2-1.2.536-1.2 1.2-1.2" />
    </svg>
  );
}
